import {FormGroup, NgForm} from '@angular/forms';
import {Mensagem, Resposta} from '../model/comum.model';
import {SelectItem} from 'primeng/api';

/**
 * Classe que agrupas todas as funcionalidades de interesse comum da aplicação
 */
export class Util {

    static isEmpty(valor: any): boolean {
        return !valor || valor.length === 0 || valor.toString().trim().length === 0;
    }

    static isNonNull(valor: any): boolean {
        return valor !== null && valor !== undefined;
    }

    static addItensCombo(itens: any[], arrayOpcoes: SelectItem[], labelField: string, valueField: string) {
        itens.forEach(item => {
            arrayOpcoes.push({label: item[labelField], value: item[valueField]});
        });
    }

    static criarDateSemHora(valor: any): Date {
        const partes = valor.split('-');
        return new Date(+partes[0], +partes[1] - 1, +partes[2]);
    }

    static markFormControlsAsDirty(form: NgForm | FormGroup) {
        Object.keys(form.controls).forEach(key => {
            form.controls[key].markAsDirty();
        });
    }

    static removerCaracteresNaoNumericos(valor: string): string {
        return valor ? valor.replace(/\D/g, '') : '';
    }

    static getMensagensResposta(resposta: Resposta<any> | any): Mensagem[] {
        if (!!resposta) {
            const transacao = (resposta.error && resposta.error.transacao) ? resposta.error.transacao : resposta.transacao;
            if (!!transacao && !!transacao.listaMensagens) {
                return transacao.listaMensagens;
            } else {
                console.log('Erro não mapeado...', resposta);

                if (!!resposta.error && !!resposta.error.message) {
                    return [{tipo: 'E', codigo: '0.0000', descricao: resposta.error.message}];
                } else if (!!resposta.message) {
                    return [{tipo: 'E', codigo: '0.0000', descricao: resposta.message}];
                } else {
                    return [{tipo: 'E', codigo: '0.0000', descricao: 'Ocorreu um erro desconhecido...'}];
                }
            }
        }
        return [];
    }

    static formatarCpfCnpj(nrCpfCnpj: string | number): string {
        const nrDocumento = this.removerCaracteresNaoNumericos(nrCpfCnpj + '');
        if (nrDocumento.length === 11) {
            const groups = nrDocumento.match(/(\d{3})(\d{3})(\d{3})(\d{2})/);
            return `${groups[1]}.${groups[2]}.${groups[3]}-${groups[4]}`;
        } else if (nrDocumento.length === 14) {
            const groups = nrDocumento.match(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/);
            return `${groups[1]}.${groups[2]}.${groups[3]}/${groups[4]}-${groups[5]}`;
        }
        return nrDocumento;
    }

    static irParaTopoDaPagina() {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }

}
